import React, { memo } from 'react';

import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import { getCategoryColorVariant } from './CategoryCell.utils';

const CategoryCell = ({ category }) => {
  if (!category) {
    return null;
  }

  return (
    <LabelCDS size={LabelSize.S} title={category} variant={getCategoryColorVariant(category)} />
  );
};

CategoryCell.propTypes = {
  category: PropTypes.string,
};

export default memo(CategoryCell);
